export const ContentsId = {
  AutoCalculation: 'autoCalculation',
  EnsembleCalculation: 'ensembleCalculation',
  ManualCalculation: 'manualCalculation',
  MultiStations: 'multiStations',
  StatusChart: 'statusChart',
  MeshMap: 'meshMap',
  CustomCalculation: 'customCalculation',
} as const;

export type ContentsId = (typeof ContentsId)[keyof typeof ContentsId];
